import axios from 'axios';
import { APIUrlThree, APIUrlToken, GetUserId } from './Utils';

export const logEvent = async (action, site_name) => {
  const userId = GetUserId();
  if (!userId) {
    console.error("User ID not found. Cannot log event.");
    return;
  }

  const payload = {
    user_id: userId,
    action: action,
    site_name: site_name,
  };

  const options = {
    method: 'POST',
    headers: {
      'access-control-allow-origin': '*',
      'Content-Type': 'application/json',
      'X-API-Key': APIUrlToken(),
    },
    url: `${APIUrlThree()}/log_user_event`,
    data: payload,
  };

  try {
    await axios(options);
  } catch (error) {
    console.error('Error logging event:', error);
  }
};
